<div
  class="icon-button-box"
  [matMenuTriggerFor]="menu"
  #menuTrigger="matMenuTrigger"
>
  <ng-container *ngIf="!uploadButtonText">
    <button
      class="icon-button"
      mat-icon-button
      (click)="handleClickIconButton($event)"
      [disabled]="disabled"
    >
      <mat-icon
        [fontIcon]="fontIcon"
        [matTooltip]="tooltip"
        [matTooltipPosition]="positionTooltip"
        matTooltipShowDelay="10"
        matTooltipHideDelay="10"
      ></mat-icon>
    </button>
  </ng-container>
  <ng-container *ngIf="uploadButtonText">
    <button
      class="icon-button sample-button sample-button--primary"
      (click)="handleClickIconButton($event)"
    >
      {{ uploadButtonText }}
    </button>
  </ng-container>
</div>
<mat-menu #menu="matMenu">
  <button
    *ngFor="let option of options"
    mat-menu-item
    (click)="handleClickMenuOption(option)"
  >
    {{ option.name }}
  </button>
</mat-menu>
